import { useEffect } from "react";
import { matchRoutes, useLocation } from "react-router-dom";
import { ROUTE_OBJECTS } from "./routePatterns";

const APP = "VibeLink";

// Tab / history title per route pattern (routePatterns.js). A pattern missing here falls back to
// the app name; a path that matches no pattern is the not-found page.
const TITLES = {
  "/auth/login": "Sign in",
  "/auth/signup": "Create account",
  "/auth/forgot": "Reset password",
  "/auth/verify": "Verify your email",
  "/clubs": "Clubs",
  "/clubs/new": "Create a club",
  "/clubs/:clubId": "Club",
  "/manage": "Manage club",
  "/manage/:clubId/*": "Manage club",
  "/super": "Super Admin",
  "/events": "Events",
  "/events/:eventId": "Event",
  "/profile": "Profile",
  "/profile/clubs": "My clubs",
  "/users/:userId": "Student profile",
  "/friends": "Friends",
  "/friends/find": "Find students",
  "/partners": "Partners",
  "/partners/all": "All partners",
  "/partners/:businessId": "Partner",
  "/notifications": "Notifications",
  "/settings": "Settings",
  "/settings/notifications": "Notification settings",
  "/chats": "Chats",
  "/chats/:kind/:chatId": "Chat",
};

/** The matched route pattern ("/events/:eventId"), or null when no route matches. */
export function useRoutePattern() {
  const location = useLocation();
  const matches = matchRoutes(ROUTE_OBJECTS, location);
  return matches?.length ? matches[matches.length - 1].route.path : null;
}

/** Sets document.title from the current route ("Events · VibeLink"); unknown paths read "Page not found". */
export default function usePageTitle() {
  const pattern = useRoutePattern();
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname === "/") return; // index redirect to /clubs; the next render sets the title
    const page = pattern ? TITLES[pattern] : "Page not found";
    document.title = page ? `${page} · ${APP}` : APP;
  }, [pattern, pathname]);
}
